import {Button, CardMedia, Container, Grid, Stack, Toolbar} from "@mui/material";
import logo from "./../../assets/images/logo.png";
import NavbarLink from "../shared/navbar-link";
import {Link} from "react-router-dom";

const DesktopHeader = () => {

    return (
        <Toolbar sx={{backgroundColor: "white"}}>
            <Container maxWidth="xl">
                <Grid container={true} justifyContent="space-between" alignItems="center">
                    <Grid item={true} xs="auto">
                        <Link to="/" style={{textDecoration: "none"}}>
                            <CardMedia
                                component="img"
                                sx={{height: 50, objectFit: "contain", width: 150}}
                                src={logo}
                            />
                        </Link>
                    </Grid>
                    <Grid item={true} xs="auto">
                        <Stack direction="row" justifyContent="space-between" spacing={4} alignItems="center">
                            <NavbarLink label="Home" path="/"/>
                            <NavbarLink label="About" path="/us"/>
                            <NavbarLink label="Apply" path="/apply"/>
                            <NavbarLink label="Contact" path="/contact"/>
                        </Stack>
                    </Grid>
                    <Grid item={true} xs="auto">
                        <Link to="/apply" style={{textDecoration: "none"}}>
                            <Button
                                disableElevation={true}
                                variant="contained"
                                size="large"
                                color="secondary"
                                sx={{textTransform: "none"}}>
                                Apply Now
                            </Button>
                        </Link>
                    </Grid>
                </Grid>
            </Container>
        </Toolbar>
    )
}

export default DesktopHeader;